/* eslint-disable max-lines-per-function */
import React, { JSX } from 'react';
import Styles from './ServiceOptionPrice.module.scss';
import ToolTip from '../../../ToolTip/ToolTip';
import { countZero } from '../../../../utils/utils';
import { RecommendedOptionsTranslations } from '../../types';
import { getTranslation } from '../../RecommendedOptionsUtils';

interface isflexitooltip {
  content: any;
  isDetailsOverlay?: boolean;
  showOptionToolTip?: boolean;
  selections?: any;
  translations: RecommendedOptionsTranslations;
  beneficiaryProducts?: any[];
}
interface BasketState {
  ottOptionsBeneficiaryProducts?: Array<{ id?: string; derivedPrice?: number }>;
}

const selectBasketState = (state: any): BasketState => {
  if (state?.basket) {
    return state.basket as BasketState;
  }

  return (state ?? {}) as BasketState;
};

const formatPrice = (value: number | string): string => {
  return countZero(value ?? 0);
};

const getBillingPeriodLabel = (
  billingEvent: string,
  translations: RecommendedOptionsTranslations
): string => {
  const normalized = billingEvent?.toLowerCase();

  if (normalized === 'monthly') {
    return getTranslation(translations, 'mo') ?? '';
  }

  if (!normalized) {
    return '';
  }

  return getTranslation(translations, normalized) ?? normalized;
};

const ServiceOptionPrice = ({
  content,
  isDetailsOverlay,
  showOptionToolTip,
  translations,
  beneficiaryProducts
}: isflexitooltip): JSX.Element => {
  let basePrice = 0;
  let discountPrice = 0;
  let derivedPrice = 0;
  let beneficiaryPrice = 0;
  const flexiDiscountPrice = '-1';
  const cycleEnd = '0';
  let oneTimeDiscountPrice = 0; // this is for storing one time cost
  let priceUnit = ''; // for showing actual price unit.

  const ottOptionsBeneficiaryProducts: any = [];

  if (beneficiaryProducts && beneficiaryProducts.length > 0) {
    beneficiaryProducts.forEach((prod: any) => {
      if (prod?.id && prod?.derivedPrice && content?.id === prod?.id) {
        ottOptionsBeneficiaryProducts.push({
          id: prod?.id,
          derivedPrice: prod?.derivedPrice
        });
      }
    });
  }

  const findPrice = () => {
    const monthlyPrices = content?.prices?.filter((price: any) => price?.billingEvent == 'monthly');
    const oneTimePrices = content?.prices?.filter((price: any) => price?.billingEvent == 'paynow');

    if (monthlyPrices?.[0]) {
      basePrice = monthlyPrices?.[0]?.value || '0';
      if (monthlyPrices?.[0]?.priceAlteration) {
        monthlyPrices?.[0]?.priceAlteration.map((priceAlteration: any) => {
          if (priceAlteration?.billingEvent === 'monthly') {
            discountPrice += Number(priceAlteration.value);
          }
        });
      }
    } else if (oneTimePrices?.[0]) {
      basePrice = oneTimePrices?.[0]?.value || '0';
      if (oneTimePrices?.[0]?.priceAlteration) {
        oneTimePrices?.[0]?.priceAlteration.map((priceAlteration: any) => {
          if (priceAlteration?.billingEvent === 'paynow') {
            oneTimeDiscountPrice += Number(priceAlteration.value);
          }
        });
      }
    }

    const monthlyDerivedPrices = content?.prices?.filter(
      (price: any) => price?.billingEvent == 'monthly'
    );
    const oneTimeDerivedPrices = content?.prices?.filter(
      (price: any) => price?.billingEvent == 'paynow'
    );
    derivedPrice =
      monthlyDerivedPrices?.[0]?.value ||
      oneTimeDerivedPrices?.[0]?.value ||
      basePrice ||
      oneTimeDiscountPrice ||
      0;

    priceUnit = monthlyDerivedPrices?.[0]?.billingEvent || 'oneTime';
  };

  findPrice();

  const flexiTooltipTitle = getTranslation(translations, 'simo_flexi_tooltip_title');
  const flexiTooltipText = getTranslation(translations, 'simo_flexi_tooltip_content')
    ?.replace('{0}', cycleEnd)
    .replace('{1}', basePrice.toString())
    .replace('{2}', content?.name);
  const tooltipContent = (
    <>
      <div className={Styles.toolTipTitle}>{flexiTooltipTitle}</div>
      <div className={Styles.flexiTooltipText}>{flexiTooltipText}</div>
    </>
  );
  let finalPrice = basePrice - discountPrice;
  if (finalPrice < 0) {
    finalPrice = 0;
  }

  if (ottOptionsBeneficiaryProducts?.length > 0) {
    const beneficiaryProdPrice = ottOptionsBeneficiaryProducts.filter(
      (opt: any) => opt?.id === content?.id
    );
    if (beneficiaryProdPrice?.length > 0) {
      beneficiaryPrice += Number(beneficiaryProdPrice?.[0]?.derivedPrice);
      finalPrice = Number(beneficiaryProdPrice?.[0]?.derivedPrice);
    }
  }

  return (
    <div>
      {flexiDiscountPrice != '-1' ? (
        <div className={Styles.mainDiv}>
          <div className='d-flex flex-wrap-reverse'>
            <span className={Styles.discountPrice}>
              {formatPrice(basePrice - parseFloat(flexiDiscountPrice))}
              {getTranslation(translations, 'mo')}{' '}
            </span>{' '}
            <span className={Styles.strikedPrice}>{formatPrice(basePrice)}</span>
          </div>
          {!isDetailsOverlay && !showOptionToolTip ? <ToolTip content={tooltipContent} /> : ''}
        </div>
      ) : discountPrice > 0 || beneficiaryPrice > 0 ? (
        <div className='d-flex flex-wrap-reverse'>
          <span className={Styles.discountPrice}>
            {formatPrice(finalPrice)}
            {priceUnit === 'monthly'
              ? getTranslation(translations, 'mo')
              : `/${getBillingPeriodLabel(priceUnit, translations)}.`}{' '}
          </span>
          <span className={Styles.strikedPrice}>{formatPrice(derivedPrice)}</span>
        </div>
      ) : (
        <div className={Styles.priceContainer}>
          <div className={Styles.basePrice}>
            {formatPrice(derivedPrice)}
            {priceUnit === 'monthly'
              ? getTranslation(translations, 'mo')
              : `/${getBillingPeriodLabel(priceUnit, translations)}.`}
          </div>
          {content?.id === 'HZN TV MultiBox' && (
            <div className={Styles.perUnit}>
              <label className={Styles.label}>{getTranslation(translations, 'per_unit')}</label>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default ServiceOptionPrice;
